<template>
  <button class="buy-now__shared" disabled>COMING SOON</button>
</template>

<script>
export default {

}
</script>